import DashboardDocuments from './DashboardDocuments';
import {
  PROJECT_DASHBOARD_TYPE__DOCUMENTS,
  DASHBOARD_PERSPECTIVE__PATIENTS,
  DASHBOARD_PERSPECTIVE__RESPONSES,
} from '../../../../common/constants';
import { registerType } from '../../dashboards';

registerType(PROJECT_DASHBOARD_TYPE__DOCUMENTS, {
  component: DashboardDocuments,
  perspectives: [
    {
      genericView: false,
      perspective: DASHBOARD_PERSPECTIVE__RESPONSES,
      specializations: [
        DASHBOARD_PERSPECTIVE__PATIENTS,
        DASHBOARD_PERSPECTIVE__RESPONSES,
      ],
    },
  ],
});

export default DashboardDocuments;
